module.exports = __webpack_public_path__ + "img/choco-maniacos.62db9c4a.jpg";